import { BrowserRouter as Router , Routes,Route } from "react-router-dom";
import Home from "./components/Home";
import Header from "./components/Header";
import Aboutus from "./components/Aboutus";
import Gallary from "./components/Gallary";
import Contact from "./components/Contact";
import Portalbutton from "./components/Portalbutton";
import LoginAdmin from "./components/LoginAdmin";
import LoginClerk from "./components/LoginClerk";
import { ProtectedRoute } from "protected-route-react";
import { useSelector } from "react-redux";
import Dashboard from "./components/Dashboard";
import TeacherData from "./components/TeacherData";
import Payslip from "./components/Payslip";
import Teacherinfo from "./components/Teacherinfo";
import Admission from "./components/Admission";
import AllStudent from "./components/AllStudent";
import StudentInfo from "./components/StudentInfo";
function App() {
  const {currentUser} = useSelector((state)=>state.user);
  return (

   <Router>
    <Header/>
    <Routes>
      <Route path="/" element={<Home/>}/>
      <Route path="/aboutus" element={<Aboutus/>}/>
      <Route path="/gallery" element={<Gallary/>}/>
      <Route path="/contact" element={<Contact/>}/>
      <Route path="/logindashboard"  element={<Portalbutton/>}/>
      <Route path="/login-admin"  element={<LoginAdmin/>}/>
      <Route path="/login-clerk" element={<LoginClerk/>}/>
      <Route path="/student-data" element={<AllStudent/>}/>
      <Route path="/student-fee" element={<Payslip/>}/>
      <Route path="/student-table" element={<AllStudent/>}/>
      <Route path="/admission" element={<Admission/>}/>

      <Route path="/dashboard" element={<Dashboard/>}  />

      <Route path="/teacher-data" element={<TeacherData/>}  />
      <Route path="/teacher/:id" element={<Teacherinfo/>}  />
      <Route path="/student/:id" element={<StudentInfo/>}  />
    </Routes>
   </Router>
 
  );
}

export default App;
